import React, { forwardRef } from 'react'

import { styled } from 'styled-components'

import { variables } from 'core/styles'

import { humanizeKey, getComponentName } from 'admin/helpers'

import ItemLabel from './ItemLabel'

const Divider = styled.div`
  border-bottom: 1px solid ${variables.colorBlack20};
`

type Props = {
  formKey?: string
  label: string
  placeholder?: string
  bare?: boolean
  compact?: boolean
  optional?: boolean
  margin?: string
  meta?: any
  isChanged?: boolean
  isFocused?: boolean
  recentlyActive?: boolean
  children?: any
  options?: Array<string>
}

const withLabel = (Component: React.ElementType<any>) => {
  const Label = forwardRef<typeof Component, Props>((props, ref) => {
    const {
      formKey,
      label,
      placeholder,
      bare,
      compact,
      optional,
      margin,
      meta,
      isChanged,
      isFocused,
      recentlyActive,
      ...rest
    } = props

    const displayLabel = label || placeholder || humanizeKey(formKey)
    const displayPlaceholder = placeholder || label || humanizeKey(formKey)

    const renderProps = {
      placeholder: displayPlaceholder,
      formKey: formKey,
      ref,
    }

    return bare ?
        <Component {...renderProps} label={displayLabel} {...rest} />
      : <>
          <ItemLabel compact={compact} label={displayLabel} margin={margin} optional={optional}>
            <Component {...renderProps} label={displayLabel} {...rest} />
          </ItemLabel>
          <Divider />
        </>
  })

  Label.displayName = getComponentName(Component, 'withLabel')

  return Label
}

export default withLabel
